import { render, staticRenderFns } from "./SubCommunityHome.vue?vue&type=template&id=bc75a950&scoped=true&"
import script from "./SubCommunityHome.vue?vue&type=script&lang=js&"
export * from "./SubCommunityHome.vue?vue&type=script&lang=js&"
import style0 from "./SubCommunityHome.vue?vue&type=style&index=0&id=bc75a950&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc75a950",
  null
  
)

export default component.exports